import { AxiosError } from 'axios'

import { useMutation, useQuery, UseQueryOptions } from '@tanstack/react-query'

import { LoginApiRequest, LoginApiResponse, UserDetailsApiResponse } from '../../types/user/types'
import { fetchUserDetails, login } from './index'
import { DefaultApiError } from '../types'

export const useLogin = () =>
  useMutation<LoginApiResponse, AxiosError<DefaultApiError>, LoginApiRequest>({
    mutationFn: login,
  })

export const useUserDetails = (
  oidCliente?: number | null,
  options: Partial<
    UseQueryOptions<UserDetailsApiResponse, AxiosError<DefaultApiError>>
  > = {}
) => {
  return useQuery<UserDetailsApiResponse, AxiosError<DefaultApiError>>({
    queryKey: ['userDetails', oidCliente ?? null],
    queryFn: () => fetchUserDetails(),
    ...options,
  })
}
  